import { ClassNames } from "../../../../structure";

export const setStyles = (
  type: "contained" | "outlined" | "default",
  state: "success" | "warning" | "danger" | "info",
  headerClassNames?: ClassNames,
  bodyClassNames?: ClassNames,
  containerClassNames?: ClassNames,
) => {
  const headerClassNamesStyle: ClassNames = ["h6"];
  const bodyClassNamesStyle: ClassNames = ["b3Regular"];
  const containerClassNamesStyle: ClassNames = ["bgNeutralLighterMain", "rounded", "b2Regular", "alignItemsFlexStart"];
  if (type === "contained") {
    containerClassNamesStyle.push(`bg${state[0].toUpperCase()}${state.slice(1)}Main` as any);
    headerClassNamesStyle.push(`color${state[0].toUpperCase()}${state.slice(1)}Contrast` as any);
    bodyClassNamesStyle.push(`color${state[0].toUpperCase()}${state.slice(1)}Contrast` as any);
  }
  if (type === "outlined") {
    containerClassNamesStyle.push(
      `bg${state[0].toUpperCase()}${state.slice(1)}Contrast` as any,
      "border2",
      "borderSolid",
      `border${state[0].toUpperCase()}${state.slice(1)}` as any,
    );
    headerClassNamesStyle.push(`color${state[0].toUpperCase()}${state.slice(1)}Dark` as any);
    bodyClassNamesStyle.push(`color${state[0].toUpperCase()}${state.slice(1)}Dark` as any);
  }
  if (type === "default") {
    containerClassNamesStyle.push(`bg${state[0].toUpperCase()}${state.slice(1)}Washed` as any);
    headerClassNamesStyle.push(`color${state[0].toUpperCase()}${state.slice(1)}Dark` as any);
    bodyClassNamesStyle.push(`color${state[0].toUpperCase()}${state.slice(1)}Dark` as any);
  }
  if (headerClassNames) {
    headerClassNamesStyle.push(...(headerClassNames as any));
  }
  if (bodyClassNames) {
    bodyClassNamesStyle.push(...(bodyClassNames as any));
  }
  if (containerClassNames) {
    containerClassNamesStyle.push(...(containerClassNames as any));
  }

  return {
    headerClassNames: [...headerClassNamesStyle],
    bodyClassNames: [...bodyClassNamesStyle],
    containerClassNames: [...containerClassNamesStyle],
  };
};
